const MEDALS = { 1: "🥇", 2: "🥈", 3: "🥉" };

function Entry({ entry, compact }) {
  if (entry.gap) {
    return (
      <div className="flex items-center justify-center py-1">
        <div className="flex gap-1">
          {[0, 1, 2].map((i) => (
            <div key={i} className="w-1 h-1 rounded-full bg-gray-300" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex items-center gap-2.5 px-3 py-2 rounded-xl transition-colors
        ${entry.is_me ? "bg-[#FEF0EB] border border-[#d15424]/20" : "hover:bg-gray-50"}`}
    >
      {/* Rank */}
      <span className="w-6 text-center flex-shrink-0">
        {MEDALS[entry.rank] ?? (
          <span className="text-xs font-bold text-gray-400">#{entry.rank}</span>
        )}
      </span>

      {/* Avatar */}
      {entry.avatar ? (
        <img
          src={entry.avatar}
          alt={entry.name}
          className="w-7 h-7 rounded-full object-cover flex-shrink-0"
        />
      ) : (
        <div className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-xs font-bold text-gray-500 flex-shrink-0">
          {entry.name?.charAt(0) ?? "?"}
        </div>
      )}

      {/* Name */}
      <span className={`flex-1 text-sm truncate ${entry.is_me ? "font-semibold text-[#d15424]" : "text-gray-700"}`}>
        {entry.is_me ? "You" : entry.name}
      </span>

      {/* Points */}
      {!compact && (
        <span className="text-xs font-semibold text-gray-500 flex-shrink-0">
          {entry.points} <span className="font-normal text-gray-400">pts</span>
        </span>
      )}
      {compact && (
        <span className="text-xs font-bold text-[#294a93] flex-shrink-0">{entry.points}</span>
      )}
    </div>
  );
}

export default function LeaderboardCard({ entries = [], loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
        <div className="h-4 bg-gray-100 rounded w-1/2 mb-3 animate-pulse" />
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-8 bg-gray-100 rounded-xl mb-2 animate-pulse" />
        ))}
      </div>
    );
  }

  if (!entries.length) return null;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
        <h3 className="font-semibold text-gray-800 text-sm flex items-center gap-2">
          🏆 Leaderboard
        </h3>
        <span className="text-xs text-gray-400">Points</span>
      </div>
      <div className="p-2 space-y-0.5">
        {entries.map((entry, i) => (
          <Entry key={entry.gap ? `gap-${i}` : `${entry.rank}-${entry.name}`} entry={entry} />
        ))}
      </div>
    </div>
  );
}
